import api from './api';

export const settingsService = {
  // Organization Settings
  async getOrganizationSettings() {
    const response = await api.get('/settings/organization');
    return response.data;
  },

  async updateOrganizationSettings(data) {
    const response = await api.put('/settings/organization', data);
    return response.data;
  },

  // User Management
  async getUsers(params = {}) {
    const response = await api.get('/settings/users', { params });
    return response.data;
  },

  async createUser(userData) {
    const response = await api.post('/settings/users', userData);
    return response.data;
  },

  async updateUser(id, userData) {
    const response = await api.put(`/settings/users/${id}`, userData);
    return response.data;
  },

  async deleteUser(id) {
    const response = await api.delete(`/settings/users/${id}`);
    return response.data;
  },

  async resetUserPassword(id, password) {
    const response = await api.post(`/settings/users/${id}/reset-password`, null, {
      params: { new_password: password }
    });
    return response.data;
  },

  async getEmployees() {
    const response = await api.get('/employees');
    return response.data;
  },

  // Roles & Permissions
  async getRoles() {
    const response = await api.get('/settings/roles');
    return response.data;
  },

  // System Configuration
  async getSystemConfig(category = null) {
    const params = category ? { category } : {};
    const response = await api.get('/settings/system-config', { params });
    return response.data;
  },

  async updateSystemConfig(key, value, description = '') {
    const response = await api.put('/settings/system-config', {
      config_key: key,
      config_value: value,
      description
    });
    return response.data;
  },

  // Backup & Restore
  async createBackup() {
    const response = await api.post('/settings/backup');
    return response.data;
  },

  async listBackups() {
    const response = await api.get('/settings/backup/list');
    return response.data;
  },

  // Audit Logs
  async getAuditLogs(params = {}) {
    const response = await api.get('/settings/audit-logs', { params });
    return response.data;
  },

  // Email/SMS Testing
  async testEmail(email) {
    const response = await api.post('/settings/test-email', { email });
    return response.data;
  },

  async testSms(phone) {
    const response = await api.post('/settings/test-sms', { phone });
    return response.data;
  },
    // Deposit Schemes
  async getDepositSchemes() {
    const response = await api.get('/savings/schemes');
    return response.data;
  },

  async createDepositScheme(schemeData) {
    const response = await api.post('/savings/schemes', schemeData);
    return response.data;
  },

    async updateDepositScheme(id, schemeData) {
    const response = await api.put(`/savings/schemes/${id}`, schemeData);
    return response.data;
    },

    async deleteDepositScheme(id) {
    const response = await api.delete(`/savings/schemes/${id}`);
    return response.data;
    },

    // Chart of Accounts
    async getChartOfAccounts() {
    const response = await api.get('/accounting/chart-of-accounts');
    return response.data;
    },

    async createLedgerAccount(accountData) {
    const response = await api.post('/accounting/ledger-accounts', accountData);
    return response.data;
    },

    async updateLedgerAccount(id, accountData) {
    const response = await api.put(`/accounting/ledger-accounts/${id}`, accountData);
    return response.data;
    },

    async deleteLedgerAccount(id) {
    const response = await api.delete(`/accounting/ledger-accounts/${id}`);
    return response.data;
    }
};
